module Meevo.Plugins.Client {
    class SelectEmailController {
        public email: string;
        public validateRegex: boolean;
        performRegexValidation = {
            test: (email) => {
                if (this.validateRegex) {
                    return Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR.test(email);
                } else {
                    return true;
                }
            }
        }
        static $inject = ['$mdDialog'];

        constructor(protected $mdDialog: angular.material.IDialogService) { }

        /**
         * Close modal window
         * */
        public cancel(): void {
            this.$mdDialog.cancel();
        }

        /**
         * Send
         */
        public send(): void {
            this.$mdDialog.hide(this.email);
        }
    }

    angular.module('meevo.plugins.client')
        .controller('meevo.plugins.client.SelectEmailController', SelectEmailController);
}